// src/components/ClosingNotice.js
// Shown while ApptNote winds down. Remove once the site is replaced
// with the closing page.

export const CLOSING_DATE = '1 December 2026';

export default function ClosingNotice({ forUsers = false }) {
  return (
    <div role="status" style={styles.box}>
      <p style={styles.title}>ApptNote is closing on {CLOSING_DATE}</p>
      <p style={styles.text}>
        {forUsers
          ? 'Thank you for using ApptNote. Please download your summary from Insights, then Appointment, before then. After that date your account and all your data will be permanently deleted. If you would like a copy of all your logs, email privacy@apptnote.com.'
          : 'Thank you to everyone who has used it. We are no longer accepting new sign-ups. Existing users can still sign in to download their summaries until then.'}
      </p>
    </div>
  );
}

const styles = {
  box: {
    background: '#FBF3F3',
    border: '1px solid #E8C4C4',
    borderRadius: '12px',
    padding: '14px 18px',
    margin: '12px 0 20px',
  },
  title: { fontFamily: "'DM Sans', system-ui, sans-serif", fontSize: '15px', fontWeight: 600, color: '#2C2C2A', margin: '0 0 4px' },
  text: { fontFamily: "'DM Sans', system-ui, sans-serif", fontSize: '14px', lineHeight: 1.6, color: '#4A5A66', margin: 0 },
};
